<!-- @format -->

<template>
  <Accordion title="Dados da Movimentação">
    <div class="grid grid-cols-4 gap-5">
      <InputNumber v-if="localValue.id" label="Código" placeholder="Insira Código" v-model="localValue.id" :disabled="localValue.id" />
      <Select :disabled="localValue.id" :items="filteredTypes" v-model="localValue.type" label="Tipo" required :error="localErrors.type" />

      <InputZoom
        clearable
        required
        label="Local Origem"
        v-model="localValue.idOriginWarehouse"
        :error="localErrors.idOriginWarehouse"
        database="warehouse"
        item-text="name"
        item-value="id"
        v-model:complete-object="teamObject"
        :filter="originWarehouseFilter"
        placeholder="Selecione o depósito"
        :disabled="localValue.id" />

      <InputZoom
        label="Protocolo"
        clearable
        v-model="localValue.orderProtocol"
        :error="localErrors.orderProtocol"
        required
        database="os"
        item-value="protocolo"
        :filter="computedItemsFilters"
        v-model:complete-object="completeProtocol"
        placeholder="Selecione o protocolo"
        :disabled="localValue.id" />

      <InputDateTime v-model="localValue.date" label="Data" :error="localErrors.date" timestamp required placeholder="Selecione a data" disabled />

      <InputZoom
        v-model="localValue.idConstructionProject"
        clearable
        label="Obra"
        :error="localErrors.idConstructionProject"
        database="constructionProject"
        item-text="protocolo"
        item-value="id"
        v-model:complete-object="completeObject"
        placeholder="Selecione a obra"
        :disabled="localValue.id" />

      <InputZoom v-model="localValue.idUser" clearable label="Responsável" :error="localErrors.idUser" database="user" item-text="name" item-value="id" required placeholder="Selecione o responsável" :disabled="localValue.id" />

      <TextArea class="col-span-4" v-model="localValue.description" label="Descrição" placeholder="Insira uma descrição" :error="localErrors.description" :disabled="isReadOnly" />
    </div>
  </Accordion>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted } from 'vue'
import { get } from '@/crud'
import { useFormat } from '@/composables/useFormat'
import { useStore } from 'vuex'
import moment from 'moment'

const store = useStore()
const user = computed(() => store.state.user)

const { formatDatetimeToTimezone } = useFormat()

const type = [
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Transferência', value: 'transfer' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Baixa', value: 'downward' },
]

const props = defineProps({
  modelValue: Object,
  error: Object,
  selectedProtocol: Object,
})

const originWarehouseFilter = [{ column: 'type', operator: '!=', value: 'physic' }]

const emits = defineEmits(['update:modelValue', 'update:selectedProtocol'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const completeObject = ref(null)
const teamObject = ref(null)
const protocolList = ref([])
const completeProtocol = ref({})

// Módulo para Corrigir tipos
const allTypes = [
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Transferência', value: 'transfer' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Baixa', value: 'downward' },
]

const isReadOnly = computed(() => {
  if (!localValue.value?.id) {
    return false
  }
  return !localValue.idCorrection
})

const allowedTypesByWarehouse = {
  team: ['devolution', 'transfer', 'downward'],
  physic: ['outgoing', 'devolution', 'supplierDevolution', 'transfer'],
  vehicles: ['devolution', 'transfer', 'downward'],
}

const filteredTypes = computed(() => {
  if (!teamObject.value || !teamObject.value.type) {
    return allTypes
  }

  const warehouseType = teamObject.value.type
  const allowedValues = allowedTypesByWarehouse[warehouseType] || []

  return allTypes.filter((type) => allowedValues.includes(type.value))
})

watch(teamObject, (newWarehouse) => {
  if (newWarehouse && newWarehouse.type && localValue.type) {
    const allowedValues = allowedTypesByWarehouse[newWarehouse.type] || []
    if (!allowedValues.includes(localValue.type)) {
      localValue.type = null
    }
  }
})

onMounted(() => {
  if (localValue.id) return
  // localValue.date = moment().format()
  localValue.idUser = user.value.id
})

// computeds
const computedItemsFilters = computed(() => {
  const filters = []
  if (completeObject.value && protocolList.value) {
    filters.push({ column: 'protocolo', operator: 'in', value: protocolList.value })
  }
  if (teamObject.value && teamObject.value.idSource && teamObject.value.type == 'team') {
    filters.push({ column: 'idTeam', operator: '=', value: teamObject.value.idSource })
  }
  return filters
})
// Watchers
watch(
  () => completeObject.value,
  async (newValue) => {
    if (completeObject.value) {
      const params = {
        filters: [{ column: 'idConstructionProject', operator: '=', value: completeObject.value.id }],
      }
      const response = await get('constructionProjectOs', { params })
      protocolList.value = response.data.map((el) => el.protocolo)
    } else {
      protocolList.value = null
    }
  },
  { immediate: true },
)

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})

watch(
  () => completeProtocol.value,
  (newValue) => {
    emits('update:selectedProtocol', newValue)
  },
  { deep: true },
)
</script>
